// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hoverable-link:hover {
    background-color: rgb(229, 243, 255);
    /* Change to the background color you want */
}`, "",{"version":3,"sources":["webpack://./src/pages/Documents/Documents.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,4CAA4C;AAChD","sourcesContent":[".hoverable-link:hover {\n    background-color: rgb(229, 243, 255);\n    /* Change to the background color you want */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
